/**
 * Whole features switched off in the UI without removing them (#539).
 *
 * Glass tracking (the clean-jar count on the Honey Pool and "Log Empty
 * Jars" on a vendor) was more detail than the owner wants for now. The API,
 * the tables and past entries are untouched, so switching it back on is
 * changing this value. An object rather than a bare constant so a test can
 * switch one on.
 */
export const SWITCHES = {
  glassTracking: false,
};
